import { Button } from "@monsterindia/global-ui-components";
import React from "react";

const BlockedCompaniesList: React.FC<BlockedCompaniesListProps> = ({
  isMobile,
  blockCompanyList,
  unblockCompanyHandler,
}) => {
  return (
    <>
      {blockCompanyList?.length > 0 && (
        <div
          className={`mt-3 flex flex-col items-center py-2 ${isMobile ? "bg-surface-primary-normal rounded-xl" : ""}`}
        >
          {blockCompanyList?.map((item: OptionType, index: number) => (
            <div
              key={item.id}
              className={`w-full ${index !== blockCompanyList.length - 1 ? "border-b border-gray-300" : ""}`}
            >
              <ul className="flex justify-between gap-4 py-3">
                <li className="flex items-center pl-3 text-base font-normal md:text-sm">
                  {item?.company?.text || ""}
                </li>
                <Button
                  onClick={() =>
                    unblockCompanyHandler({
                      id: Number(item.id ?? 0),
                      company: item.company ?? "Unknown Company",
                    })
                  }
                  label="Unblock"
                  modifier="secondary"
                  className="mr-3 inline-flex max-h-9 items-center justify-center gap-1"
                />
              </ul>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlockedCompaniesList;
